import { useState } from 'react'
import DirectRequestItem, { PropertyContentData } from '../DirectRequestItem'
import SeeMore from '../../app/SeeMore'
import { useSession } from '@/hooks'

function DirectRequestItemList ( props: DirectRequestItemListProps<PropertyContentData> ) {
    const {
        itemList, defaultShowItemCount = 10, marginTop = '8px', marginBottom = '8px',
        onMove, onModify,
        ...rest
    } = props

    const session = useSession()
    const [ showItemCount, setShowItemCount ] = useState( defaultShowItemCount )

    return (
        <>
            {
                itemList && itemList.map( (
                    data, idx
                ) =>
                    <DirectRequestItem
                        { ...rest }
                        key={ `${ data.id + data.telNo }` }
                        index={ idx }
                        data={ data }
                        marginTop={ marginTop }
                        marginBottom={ marginBottom }
                        isModifyAuth={ session( 'id' ) === data.userId }
                        onModify={ onModify }
                        onMove={ onMove }
                    />
                ).slice( 0, showItemCount > itemList.length ? itemList.length : showItemCount )
            }
            {
                itemList.length !== 0 &&
                    <SeeMore
                        defaultShowCount={ defaultShowItemCount }
                        setShowCount={ setShowItemCount }
                        totalList={ itemList }
                        marginTop={ marginTop }
                        marginBottom={ marginBottom }
                    />
            }
        </>
    )
}

export default DirectRequestItemList

export interface DirectRequestItemListProps<TData = any> {
    itemList: TData[]
    defaultShowItemCount?: number
    marginTop?: string | number
    marginBottom?: string | number
    onMove?: ( data: TData ) => void
    onModify?: ( data: TData ) => void
    [ key: string ]: any
}

